import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from '../Routes/HomePage';
import HomePage2 from '../Routes/HomePage2';

const Routing = () => {
    const router=createBrowserRouter([
        {
            path:"/",
            element:<HomePage2 />
        },
        {
          path:"*",
          element:<Navigate to="/" />
        }
    ])
  return (
    <RouterProvider router={router} />
  )
}

export default Routing